export class NoTokenError extends Error {
  override name = 'No token!';
}
